import { useState } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import "./home.css";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import verifyToken from "../HelperFx/verifyJwt.js";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import StandardExpressList from "../Components/ListpageExpress";
import UploadUsersPopup from "./UploadPopup";

const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;
const BackendUname = process.env.REACT_APP_BACKEND_API_USERNAME;
const BackendPwd = process.env.REACT_APP_BACKEND_API_PASSWORD;

const Users = () => {
  const jwttoken = sessionStorage.getItem("authToken");
  const decoded = verifyToken(jwttoken) || {};
  const { userName } = decoded;
  const navigate = useNavigate();
  const [showUploadPopup, setShowUploadPopup] = useState(false);

  const token = Buffer.from(`${BackendUname}:${BackendPwd}`, "utf8").toString(
    "base64",
  );
  const usersUrl = `${REACT_EXPRESS}/users`;

  const downloadUsers = async () => {
    let lvUsers = [];
    try {
      const response = await axios.get(usersUrl, {
        headers: { Authorization: `Basic ${token}` },
      });
      lvUsers = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
    } catch (error) {
      console.log(error);
    }

    Swal.fire({
      title: '<span style="font-size:1.3rem">Are you sure?</span>',
      text: "You want to export the users to Excel?",
      showCancelButton: true,
      confirmButtonText: "Yes, export",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (!result.isConfirmed) return;
      try {
        const exportData = lvUsers.map((item) => ({
          UserName: item.userName,
          CustomerNo: item.customerNo,
          CustomerName: item.customerName,
          JobTitle: item.jobTitle,
          IsAdmin: item.isAdmin,
          PhoneNo: item.phoneNo,
          Email: item.email,
          Blocked: item.blocked,
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Users");
        const date = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(wb, `User_Export_${date}.xlsx`);
        Swal.fire({
          title: `<span style="font-size:1.3rem">Exported Successful!</span>`,
          text: "Users data has been exported to Excel",
          timer: 2000,
          showConfirmButton: true,
        });
      } catch (error) {
        console.error("Error exporting Users:", error);
        Swal.fire({
          title: "Export Failed",
          text: "An error occurred while exporting Users",
          icon: "error",
        });
      }
    });
  };

  const columns = [
    {
      name: "User Name",
      selector: (row) => (
        <span
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/User`, { state: { id: row.userName } })}
        >
          {row.userName}
        </span>
      ),
      sortable: true,
    },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "User Type", selector: (row) => row.isAdmin, sortable: true },
    { name: "Job Title", selector: (row) => row.jobTitle, sortable: true },
    {
      name: "Customer Name",
      selector: (row) => row.customerName,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (row.blocked ? "Blocked" : "Active"),
      sortable: true,
    },
  ];

  const actions = [
    {
      name: "SMTP Setup",
      fx: () => navigate("/SMTPSetup"),
    },
    {
      name: "User Logs",
      fx: () => navigate("/UserLogs"),
    },
    {
      name: "Upload Users",
      fx: () => setShowUploadPopup(true),
    },
    {
      name: "Download Users",
      fx: downloadUsers,
    },
  ];

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <StandardExpressList
          apiUrl={usersUrl}
          token={token}
          columns={columns}
          actions={actions}
          searchKeys={["userName", "email", "customerNo", "customerName", "jobTitle"]}
          pageCaption="User Information"
          actionvisibility
          cardPageLink="User"
          redirectTo="home"
          infiniteScroll
        />
      </div>
      <Footer />
      {showUploadPopup && (
        <UploadUsersPopup
          apiUrl={usersUrl}
          createdBy={userName}
          onClose={() => setShowUploadPopup(false)}
        />
      )}
    </div>
  );
};

export default Users;
